export const colors = {
  white: '#FFFFFF',
  black: '#000000',

  primary50: '#962800',
  primary40: '#C83600',
  primary30: '#FA4300',
  primary20: '#FC8E66',
  primary10: '#FFECE5',

  secondary50: '#001833',
  secondary40: '#3F4C61',
  secondary30: '#778190',
  secondary20: '#B0B5BE',
  secondary10: '#E9EAED',

  neutral100: '#000000',
  neutral70: '#262626',
  neutral60: '#474A4D',
  neutral50: '#6B6E73',
  neutral40: '#9FA4AB',
  neutral30: '#E1E4E6',
  neutral20: '#EDEFF2',
  neutral10: '#F6F7F9',
  neutral0: '#FFFFFF',

  success50: '#184933',
  success40: '#216345',
  success30: '#297C57',
  success20: '#81B29B',
  success10: '#D9E7E1',

  alert50: '#975B01',
  alert40: '#CB7A01',
  alert30: '#FF9A01',
  alert20: '#FEC26A',
  alert10: '#FFF4E3',

  error50: '#79191D',
  error40: '#A32227',
  error30: '#CD2B31',
  error20: '#E18287',
  error10: '#F6D9DB',

  azulRadiante50: '#014697',
  azulRadiante40: '#025FCB',
  azulRadiante30: '#0277FF',
  azulRadiante20: '#6BB0FE',
  azulRadiante10: '#D2E7FF',

  azulFuso30: '#C1D8EA',
  brancoAzure30: '#F1F2F2',
  brancoOstra30: '#DDD8CC',

  laranjaLuminoso30: '#FA4300',
  azulMeiaNoite30: '#001833',
  azulMeiaNoite80: '#33465C',
  azulPedra30: '#9AB2CA',
  azulPedra20: '#EBF0F4',
  azulPedra60: '#C2D1DF',
  alabastro30: '#F6F2E7',
};
